webpackJsonp([206160172539475],{

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _components = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TermsOfServicesPage = function TermsOfServicesPage(_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        _components.PageWrapper,
	        { title: 'Terms Of Services' },
	        _react2.default.createElement(
	            'div',
	            { className: 'contentPage' },
	            _react2.default.createElement(
	                'p',
	                { className: 'text-center' },
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    data.site.siteMetadata.title,
	                    ' , TERMS OF USE'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'EFFECTIVE July 1, 2018'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    data.site.siteMetadata.title
	                ),
	                '(\u201Cus\u201D, \u201Cwe\u201D, \u201Cour\u201D) operates ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/' },
	                    data.site.siteMetadata.domain,
	                    ' '
	                ),
	                ', including any and all associated domains (\u201CWebsite\u201D).'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'PLEASE READ THESE TERMS OF USE CAREFULLY BEFORE USING WEBSITE, INCLUDING ALL POLICIES AND PROCEDURES PUBLISHED ON WEBSITE (COLLECTIVELY \u201CTERMS\u201D).',
	                _react2.default.createElement('br', null),
	                'THESE TERMS ARE A LEGALLY BINDING AGREEMENT BETWEEN YOU AND US AND GOVERN THE ACCESS OR USE OF WEBSITE, INCLUDING CONTENT, PRODUCTS, AND SERVICES WE PROVIDE THROUGH WEBSITE (DEFINED HEREIN), AND APPLY TO ALL INDIVIDUALS INCLUDING VISITORS, USERS, AND CLIENTS. WHEN YOU ACCESS AND USE WEBSITE, YOU, OR ON BEHALF OF AN ENTITY YOU REPRESENT, ACCEPT AND AGREE TO COMPLY WITH THESE TERMS. ADDITIONALLY, YOU REPRESENT AND WARRANT THAT YOU ARE AT LEAST 18 YEARS OF AGE AND HAVE THE LEGAL CAPACITY AND AUTHORITY TO ENTER INTO THESE TERMS. IF YOU DO NOT AGREE WITH THESE TERMS IN FULL, YOU MAY NOT ACCESS AND/OR USE WEBSITE.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'OUR SERVICES '
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We provide a paid service to obtain Federal Tax Identification Numbers from the Internal Revenue Service (\u201CIRS\u201D) (\u201CServices\u201D). We act as a \u201CThird Party Designee,\u201D pursuant to IRS Form SS-4, and prepare and submit applications for Employer Identification Numbers (\u201CEIN\u201D) to the IRS on behalf of our clients. We are not affiliated with the IRS or any other governmental or regulatory body or agency.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'FEES AND REFUND POLICY'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We provide the services for the rates listed on the Website, which are incorporate herein by reference. All amounts are due and payable in accordance with our invoices.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We will do everything we can to process your application in one business day, provided all information provided to us is accurate. If we cannot complete the EIN process and no EIN is assigned due to an unfixable error, we will provide a refund minus a $10 processing fee.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If there are any issues with your order, please contact our support team at ',
	                data.site.siteMetadata.supportPhone,
	                '  or ',
	                data.site.siteMetadata.supportEmail,
	                ' to obtain a full refund.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'For incomplete orders due to inaccurate information, the customer will be contacted via email by us to rectify the issue, and we will try one additional time to obtain your EIN. If at that point there is another error, the customer will be refunded on the next business day less a $10 processing fee.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'SS4 Fax \u2013 Ref 101: For EIN applications resulting in a Reference 101 error from the IRS, Govt Assist may contact you via e-mail with instructions on how we will proceed with manually filing your application with the IRS. You will receive an e-mail with a completed SS-4 form PDF on the same day that the Ref 101 error occurred, and the PDF will require your electronic signature. Then, Govt Assist will continue to process your EIN with the IRS, and you will receive the EIN via e-mail in 7-10 business days due to the manual processing wait time for all Reference 101 errors. In the event that there is an additional error within the Ref 101 application and Govt Assist cannot process your application as a Third Party Designee, we will issue a refund of the service fee, minus a $25 processing fee.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'USE OF WEBSITE AND SERVICES'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Subject to these Terms, we grant you a non-exclusive and non-transferable revocable license to access and use Website and Services solely for individual and non-commercial use, whether for personal or business purposes.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'In order to access and use Website and Services, you must be over 18 years of age and can lawfully enter into a contract under applicable laws and regulations. If you are accessing or using Website or Services on behalf of an entity, you represent and warrant that you are an authorized representative of the entity with full legal power and authority to enter into a contract and bind entity to these Terms.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You must abide by these Terms, any technical restrictions on Website or Services, and with all applicable laws and regulations, including regulations regarding online conduct and content. Prohibited conduct, or assisting others in such conduct, includes the following:'
	            ),
	            _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Any illegal, fraudulent, harmful, abusive, threatening, obscene, defamatory, or libelous activity;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Intent to misrepresent, omit, or delete information;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Attempts to impersonate any person or entity or intent to disguise yours or others\u2019 identity or contact information;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Violations of personal privacy of and/or victimizes, harasses, humiliates, or intimidates others;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Unauthorized disclosure of confidential or insider information;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Creation of, or attempts to create, a similar or competitive website, service, product, or mobile application through the access and use of Website and Services;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Infringement or misappropriation of intellectual property; or'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Implementation of any viruses or other programs that disrupts or interferes with the access or use of Website or Services by us or others or intercepts or steals data or information.'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                ' '
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We may suspend or permanently terminate your account at any time for any reason, including if a suspicion arises that you have violated these Terms in your access and use of Website and Services.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'INTELLECTUAL PROPERTY '
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We are the sole owner with all title and interest in Website and Services and any and all intellectual property (defined herein) related to Website and Services. We reserve all rights in and to any and all intellectual property. Any rights, licenses, and transfers of ownership, if any, may only be expressly granted pursuant to these Terms and never by implication. If any intellectual property right vests in you, your representatives, or in the entity you represent, you hereby, and cause representatives or entity to, irrevocably and completely assign and transfer all such right, title, and interest to us without royalty or any other consideration.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Intellectual property includes:'
	            ),
	            _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'All trademarks, trade dress, and service and design marks, including domain names, logos, slogans, and uniform resource locators;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'All trade secrets including business practices, operations, applications, techniques, processes, procedures, methods, know-how, ideas, research and development, business and marketing plans and proposals, financials, pricing, costs, customer lists, vendor lists, supplier lists, hardware, software, systems, technical data, source codes, formulas, specifications, and drawings;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'All patents and pending patents;'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'All works of authorship and copyrightable works; and'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Any and all inventions and improvements regardless of status, condition, and patentability.'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                ' '
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'All intellectual property includes any and all work product, goodwill, applications and registrations, renewals, reissuances, extensions, modifications, improvements, additions, derivative works, and all related documents and matters.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'Restrictions'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You may not use, sell, license, transfer, remove, alter, duplicate, translate, reverse engineer, reproduce, distribute, transmit, obscure, commercially exploit or take any other action regarding Website or Services and any intellectual property, proprietary marks, or right notices incorporated in or accompanying Website or Services, in whole or in part, without our express prior written consent.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'em',
	                    null,
	                    'Feedback'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'When you provide us with feedback, suggestions, or comments (\u201CFeedback\u201D) regarding access and use of Website and Services, you hereby assign and transfer all rights to Feedback and related information to use in any manner we decide pursuant to applicable law. Because Feedback is non-confidential and non-proprietary, you will not submit any information or ideas considered to be confidential or proprietary.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'INFORMATION USE AND DISCLAIMERS'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We require that you submit certain information when providing Services, including personal, contact, and billing information (\u201CPersonal Information\u201D). You represent and warrant that any and all information you provide us through Website and in connection with Services is complete, accurate, and in compliance with these Terms. You are fully responsible for such information and assure it does not contain any viruses or other malware that may damage or interfere with Website when submitted online.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'By submitting Personal Information, you agree to let us contact you and share Personal Information with the IRS and certain affiliates, business partners, and other third parties in order to service you. You acknowledge that the IRS and such third parties may maintain your Personal Information and may contact you regardless of whether you opted in on the National Do Not Call List through the Federal Trade Commission or a similar list.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'For more on how we collect, use, and disclose your information, please read our Privacy Policy found here: ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/privacy-policy/' },
	                    'https://',
	                    data.site.siteMetadata.domain,
	                    ' /privacy-policy/'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'THIRD-PARTY WEBSITES'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Website or Services may contain links to other websites or display advertisements for third parties unaffiliated with and are not operated or controlled by us. Access to these websites and advertisements are provided as a convenience to you and are not reviewed, monitored, approved, endorsed, or warranted by us. We are not responsible, and make no representations, for such websites and advertisements. Once you leave Website, you are subject to that third-party\u2019s terms of use and privacy policies. You click and use these third-party websites and advertisements at your own risk and are encouraged to do so with precaution and investigate as necessary before proceeding.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'For more information, please refer to our Privacy Policy found here: ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '/privacy-policy/' },
	                    'https://',
	                    data.site.siteMetadata.domain,
	                    ' /privacy-policy/'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'LEGAL DISCLAIMER'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We do not verify, and are not responsible for, the accuracy of the information submitted on EIN applications. We are not a law firm and do not offer legal advice or recommendations. Our communications are not protected by attorney-client privilege in any way. Any individual who needs legal assistance must contact an attorney or law firm licensed in his or her jurisdiction.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'DISCLAIMER OF WARRANTY'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We do not make any warranties, representations, or promises in these Terms, and you do not rely on any such warranties, representations, or promises when accessing or using Website and Services. We expressly disclaim all warranties, representations, and promises, express or implied, including warranties of merchantability, fitness for a particular purpose, and workmanlike quality with respect to Website, Services, and any products, materials, information, data, or content provided by us or any third party. Website and Services are provided \u201Cas-is\u201D and we are not liable for any interruptions, errors, omissions, or vulnerabilities beyond our control.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You acknowledge and agree that any access or use of Website or Services is done at your own discretion and risk. You are fully responsible for data transmitted to and from Website by or on behalf of you, which may be done so unencrypted and over various networks.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'To the extent we cannot disclaim any warranty, representation, or promise as a matter of law, the scope and duration of such shall be the minimum permissible under applicable law.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'RELEASE OF LIABILITY'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'WE, INCLUDING ANY OF OUR AFFILIATES, SUCCESSORS, ASSIGNS, AND RESPECTIVE OFFICERS, DIRECTORS, AGENTS, REPRESENTATIVES, EMPLOYEES, LICENSORS, AND LICENSEES, (\u201CRELEASED PARTIES\u201D) ARE NOT LIABLE TO YOU FOR ANY AND ALL SPECIAL, INDIRECT, INCIDENTAL, PUNITIVE, OR CONSEQUENTIAL INJURIES OR DAMAGES, ARISING FROM OR RELATED TO THESE TERMS AND ACCESS AND USE OF WEBSITE AND SERVICES, INCLUDING BODILY INJURY, DEATH, LOSS OF REVENUE, LOSS OR CORRUPTION OF DATA, PROFITS, OR OPPORTUNITIES, AND CLAIMS BY ANY THIRD PARTY, EVEN IF YOU OR ANY THIRD PARTY HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. WE ARE NOT LIABLE FOR ANY FAILURE OR DELAY DUE TO MATTERS BEYOND OUR REASONABLE CONTROL, INCLUDING FORCE MAJEURE. THIS APPLIES TO ALL CAUSES OF ACTION IN THE AGGREGATE, INCLUDING BREACH OF CONTRACT, BREACH OF WARRANTY, NEGLIGENCE, STRICT LIABILITY, AND OTHER TORTS.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'BY ACCESSING AND USING WEBSITE AND SERVICES, YOU AGREE NOT TO SUE OR INSTITUTE ANY CAUSE OF ACTION OR ANY LEGAL PROCEEDING AGAINST THE RELEASED PARTIES. IN NO EVENT SHALL ANY LIABILITY OF THE RELEASED PARTIES RELATED TO THESE TERMS AND ACCESS AND USE OF WEBSITE OR SERVICES EXCEED THE FEES PAID BY YOU TO US DURING THE 12 MONTHS IMMEDIATELY PRECEDING THE CLAIM OR EVENT GIVING RISE TO SUCH LIABILITY.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'IF YOU ARE A CALIFORNIA USER, YOU HEREBY WAIVE CALIFORNIA CIVIL CODE SECTION 1542, WHICH STATES: \u201CA GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR.\u201D'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'THE FOREGOING SHALL NOT APPLY TO THE EXTENT PROHIBITED BY APPLICABLE LAW.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'INDEMNIFICATION'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You agree to release, indemnify, defend, protect, compensate, reimburse, and hold harmless each of the Released Parties from and against any and all claims, damages, losses, costs, fees (including reasonable attorneys\u2019 fees), liabilities, or injuries suffered arising out of, or relating to, these Terms and the access and use of Website and Services to the fullest extent provided by applicable law. This includes your breach of any warranty, representation, covenant or other term of provision of these Terms, violation of applicable laws or regulations, negligent acts or omissions, and any content posted, submitted, or otherwise made available on Website or in connection with Services.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We will promptly notify you of any claim for indemnification. All provisions of these Terms regarding indemnification shall survive termination of our relationship and these Terms. The foregoing shall not apply to the extent prohibited by applicable law.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'CHANGES'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'These Terms are effective as of the date indicated herein. We may update or make changes to these Terms at any time without notice to you by written agreement signed by an authorized executive or representative or by publishing a revised version on Website. Such changes will go into effect immediately upon posting. The current posted version of these Terms shall apply on the date you access the Website and shall only apply to information collected thereafter. As a result, you are encouraged to check these Terms each time you access Website and review for any updates or changes before using Website and Services. Your continued use of Website and Services after we post any updates or changes will constitute your acknowledgement of such modifications and consent to abide and be bound by the modified Terms.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Additionally, we may update and make changes to Website and Services, subject to these Terms, at any time without notice to you.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'SEVERABILITY'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If any part, term, or provision of these Terms are held to be invalid, illegal, unenforceable, or in conflict with any valid controlling law in any respect, the remaining terms and provisions shall continue in full force and effect without being impaired or invalidated in any way. If applicable, such part, term, or provision shall be modified and interpreted which most closely approximates the original intent and purpose.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'TERMINATION'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We may, in our sole and absolute discretion, permanently terminate your account at any time, without notice, for any reason whatsoever. Upon termination, we may immediately deactivate or delete any and all information related to your account. We are not liable to you or any other person for termination of your account and deletion of information.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'DISPUTE RESOLUTION'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'These Terms and any access to or use of Website or Services shall be governed by the law of in the State of California without regard to the conflicts of law principles thereof.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Any disputes shall be reported to our customer service by contacting us via email at ',
	                data.site.siteMetadata.supportEmail,
	                ', We will try to promptly and amicably resolve any disputes. If we are unable to resolve the dispute, it shall be settled by final and binding arbitration in Los Angeles County in the State of California before a single arbitrator in an individual capacity (and never as a plaintiff or class member seeking class-wide relief). We must agree on the rules and procedures of arbitration. If we are unable to agree within 15 days, arbitration shall be administered by JAMS pursuant to its Streamlined Arbitration Rules and Procedures and the arbitrator shall apply the laws applicable in the State of California without regard to the conflict of laws rules thereof.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Judgment on the award outcome and award rendered by the arbitrator may be entered into any court having jurisdiction thereof. The award shall determine the prevailing party, allocate all or part of the legal costs including the arbitrator fees and reasonable attorneys\u2019 fees of the prevailing party, and require payment by the non-prevailing party.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Despite mandatory arbitration, either of us may seek an injunction or other provisional remedies to aid arbitration from a court of appropriate jurisdiction.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'MISCELLANEOUS'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'These Terms constitute the entire understanding and agreement between you and us with respect to its subject matter and supersedes all prior and contemporaneous agreements, understandings, inducements, warranties, representations, or conditions, express or implied, written or oral, preceding these Terms.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Failure or delay, at any time, to enforce any term or condition of or to exercise any right or remedy in these Terms shall not be construed to be a waiver of the right to enforce or exercise such term, condition, right, or remedy. A waiver of any one term, condition, right, or remedy of these Terms or any breach shall not constitute a permanent waiver of such term, condition, right, or remedy or any subsequent breach thereof in the future.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'You may assign or transfer your rights under these Terms to any third party that consents and agrees to be bound by these Terms. Additionally, we may assign our rights under these Terms to any third party without condition. These Terms shall be binding on you, us, and our successors and assigns.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'CONTACT'
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'If you have any questions regarding these Terms, you may contact us via email at ',
	                data.site.siteMetadata.supportEmail
	            )
	        )
	    );
	};
	
	exports.default = TermsOfServicesPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-of-services-js-b3998d2cfd6f246ce41a.js